import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import { Button } from 'reactstrap';

import axios from 'axios';

import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class NewsItens extends Component {
    state = {
        news: []
    }

    /* componentDidMount() {
         axios.get(`https://g4p5724ade.execute-api.us-east-1.amazonaws.com/prod/last_posts`, {
             headers: {
                 'x-api-key': 'u3NsYwnWwi2UbDiE35AUN1LnqS3ltBg95u9bMViR '
             }
         })
             .then(res => {
                 const news = res.data;
                 this.setState({ news });
             })
     }*/

    render() {
        const { t } = this.props;

        let settings = {
            dots: true,
            infinite: true,
            speed: 500,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            initialSlide: 0,
            autoplay: true,
            adaptiveHeight: true,
            autoplaySpeed: 10000,
            pauseOnHover: true
        };

        return (

            <Fragment>
                <Slider  {...settings}>
                    {/*this.state.news.map(item =>

                        <div key={item} className="h-100 d-flex justify-content-center align-items-end">
                            <div className="slider-content">
                                <div>
                                    {t('news.last_posts')}
                                </div>
                                <h4>{item.title}</h4>
                                <p>
                                    <a href={`https://www.intexfy.com/${item.name}`} target="_blank" rel="noopener noreferrer">
                                        <Button outline color="primary" size="lg">{t('news.read_more')}</Button>
                                    </a>
                                </p>
                            </div>
                        </div>
                    )*/}
                </Slider>
            </Fragment>
        );
    }
}

NewsItens.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate(NewsItens);